<template>
  <div id="algorithm-detail">
    <template v-if="product">
      <ProductBanner
          :product="product"
          use-apply-button="true"
      ></ProductBanner>
    </template>

    <div class="inner">
      <div class="swiper-container swiper-lnb">
        <div class="swiper-wrapper">
          <div class="swiper-slide" style="width:auto !important; margin-right:32px;"><a href="#">알고리즘소개</a></div>
          <div class="swiper-slide" style="width:auto !important; margin-right:32px;"><a href="#">지표설명</a></div>
          <div class="swiper-slide" style="width:auto !important; margin-right:32px;"><a href="#">설치방법</a></div>
          <div class="swiper-slide" style="width:auto !important; margin-right:32px;"><a href="#">사용효과</a></div>
          <div class="swiper-slide" style="width:auto !important; margin-right:32px;"><a href="#">REVIEW</a></div>
          <div class="swiper-slide" style="width:auto !important; margin-right:32px;"><a href="#">BY SSABU</a></div>
        </div>
      </div>

      <div class="inner-wrap">
        <div class="content">
          <div class="content1">
            <p class="sub">BUYSELL(BASEL) MAJOR SWING 6.0은 <br class="dp-no"><strong>장기적인 시드의 우상향</strong>을 목표로 만들어진 알고리즘 입니다.</p>
            <p class="exp">바셀은 주가가 상승 할 때 같이 시드를 상승시키고 주가가 떨어 질 때 매매를 쉬어주는 과정을 반복하여 장기적인 시드의 우상향을 목표로 만들어진 알고리즘 입니다. <br>6.0 업그레이드 버전은 가격 움직임을 이용하여 구간을 나누게 하였고 더 세밀하고 신뢰도 높은 구간 설정을 가능하게 하였습니다.</p>
          </div>

          <div class="content2">
            <h3 class="tit">지표 설명</h3>
            <p class="exp">기존 무료배포버전과 달리 새로운 수식을 이용하여 새로운 지표를 만들어서 구간을 나눠주는 알고리즘을 구현하였습니다. 바셀에 들어간 여러가지 수식 및 특정 지표들은 모두 새롭게 지표를 만들어서 일정조건이 되면 시그널(신호)을 주도록 구현 하였습니다. 원래 배포버전에서 거래량의 변화를 계산하여 배경에 색깔을 표시 했던 것과 달리 6.0 업그레이드 버전은 가격 움직임을 이용하여 구간을
              나누게 하였고 더 세밀하고 신뢰도 높은 구간 설정을 가능하게 하였습니다. ( RSI같은 특정 지표에서 과매수 과매도라는 표현을 하면서 거래량을 이용하는 듯한 표현을 하지만 사실 RSI는 이평선 수식을 조금 변형한 거래량과 상관이 없는지표 ) <br>RSI공식 = (n일 동안의 종가 상승분 평균) / (n일 동안의 종가 상승분 평균+n일 동안의 종가 하락분 평균) X 100)</p>
            <p class="exp">※ RSI와 같은 공식을 쓰는 지표 혹은 기존에 있던 지표들은 리페인팅이 있을 수 밖에 없음 <br>(ex: 70ma 105ma 골든크로스 등등 같은 조건들은 같은 기간동안 백테스트 결과와 실제 매매 횟수가 다름, 실제로는 현재 봉에서 신호가 떴다가 지워지면서 리페인팅을 발생시켜 백테스트 결과보다 더 많은 매매 횟수를 발생 시킴 그리고 대부분이 안좋은 결과로 이어짐)</p>
            <p class="exp">※ 기존의 지표들로 리페인팅을 없애려면 봉이 마감하고 나서 신호를 띄우는 방법이 있는데 이는 매수와 매도가 1칸씩 밀리게 발생해서 신뢰도가 매우 낮음. ( 타점이 밀려 승률 및 수익률이 줄어듬 )</p>
            <p class="exp">※ 이점을 보완한 바셀은 봉 생성 중에 신호가 발생하고 그 신호가 리페인팅도 없음. ( 한 번 시그널이 뜨면 지워지는 일이 없음 )</p>
            <p class="exp">실시간으로 신호가 생겼다 지워지다가 봉 마감시에 유리한 신호만 저장하는 기존 리페인팅이 있는 구조가 아니기 때문에 시드변화 그래프와 같은 결과를 신뢰 할 수 있고 실시간 지표라고 할 수 있음.</p>
            <ul class="exp-box">
              <li>
                <div class="img-wrap">
                  <ImageModal image-url="~@/assets/images/basel/basel-1.png"/>
                </div>
                <p class="exp">큰 추세로 봤을 때 매매 하기 좋은 자리인 상승 구간에서만 매매 신호가 나오도록 하였습니다. 상승 구간 안에서 신뢰도 높은 매매기법을 알고리즘으로 적용하였고 기존의 다른 지표를 이용하면 매수나 매도에 신호가 실시간으로 나타났다가 지워지는 리페인팅현상이 발생하기 때문에 리페인팅을 막기 위해서 구간 안에 디테일을 더해주는 지표들 또한 새로운 수식으로 새롭게 만들어서
                  적용하였습니다. 기존의 지표들을 사용한 전략테스터에서 승률이 아무리 높게 혹시라도 100%로 잡히는 수식이 있더라도 실시간으로 신호가 계속 바뀌다가 봉 마감시 유리한 신호만 과거 기록에 남기 때문에 승률이 아무리 좋아도 리페인팅이 있는 지표는 실전과 다른 결과를 만들어 매매에 대한 신뢰도가 없다고 얘기 할 수 있습니다. 바셀은 리페인팅이 없기 때문에 매매 시그널들이 지워지지 않아 과거의 데이터
                  및 승률을 실시간으로도 신뢰 할 수 있습니다.</p>
              </li>
              <li>
                <div class="img-wrap">
                  <ImageModal image-url="~@/assets/images/basel/basel-2.png"/>
                </div>
                <p class="exp">차트에서 매매신호는 좌측에 스크린 샷과 같이 확인 할 수 있습니다. 실시간으로 BUY와 SELL 신호가 1:1 비율로 리페인팅 없이 표시 되도록하였고 BUY나 SELL이 발생하는 시점에 가격을 BUY는 빨간색 가로선으로 SELL은 파란색 가로선으로 표시 해줍니다. 지표에서 설정을 이용하여 해당 신호에 알람설정 및 추천 신호에 맞게 매매를 진행 했을 시에 존버와 비교하여
                  시드가 어떻게 변하였는지 확인해 볼 수 있습니다. 시드변화 그래프는 모든 시드를 매매에 투입한다고 가정하여 1:1로 발생하는 매수신호와 매도신호만을 이용하여 시드변화를 계산하였습니다.</p>
              </li>
            </ul>
          </div>

          <div class="content3">
            <h3 class="tit">설치 및 설치방법</h3>
            <ul class="faq-list">
              <ExpendableCard
                  title="설치방법"
                  :contents="[
                      {description: '<b>1.</b> 해당 지표를 전송 받으시면 트레이딩뷰 메인 페이지에서 위에 표시 된 차트부분을 클릭하고 차트를 실행합니다.', thumbnailUrl : '/images/basel/install-1.png'},
                      {description: '<b>2.</b> 위의 차트 화면이 나오면 지표를 클릭 해줍니다.', thumbnailUrl : '/images/basel/install-2.png'},
                      {description: '<b>3.</b> 위의 창이 뜨면 ①인바이트 온리 스크립트를 클릭 한 뒤에 해당 메뉴 안에 전송되어 있는 ②BuySell(Basel major swing ver1.0)을 클릭해줍니다.</br>( 1.0으로 설치하면 설치는 6.0으로 됨 )', thumbnailUrl : '/images/basel/install-3.png'},
                      {description: '<b>4.</b> 처음 설치시 위와 같이 차트에 시그널이 발생하고 차트 하단에 빨간색과 하늘색의 가로줄이 생기면 지표가 알맞게 적용 된 것 입니다.</br>(분봉은 먼저 4H 봉으로 체크하시면 되고 분봉설정 추가 설명은 13 page 참고 )</br>설정에서 체크 박스를 통해서 매매시그널을 볼 것인지, 시드변화그래프를 볼 것인지 선택 할 수 있고 알람 설정 등의 기능을 설정 할 수 있습니다.', thumbnailUrl : '/images/basel/install-4.png'},
                  ]"
              ></ExpendableCard>
              <ExpendableCard
                  title="차트설정"
                  :contents="[
                      {description: '<b>1.</b> 바셀을 이용하여 매매 시그널을 보려면 먼저 왼쪽의 스크린 샷에 표시한 지표 옆의 톱니바퀴 같이 생긴 설정 부분을 눌러줍니다.', thumbnailUrl : '/images/basel/chart-setting-1.png'},
                      {description: '<b>2.</b> 그리고 위와 같은 설정 창이 뜨면 스크린샷에 표시된 BuySell Wallet과 JohnBer Wallet의 체크를 해제해줍니다.</br>(차트에 하늘색, 빨간색의 가로선이 없어지게 됨)', thumbnailUrl : '/images/basel/chart-setting-2.png'},
                      {description: '<b>3.</b> 설정의 Wallet을 해제한 뒤에 시드변화 그래프를 안나오게 설정 했으면 지표 옆의 ⚪️⚪️⚪️( 더보기 ) 버튼을 누릅니다.', thumbnailUrl : '/images/basel/chart-setting-3.png'},
                      {description: '<b>4.</b> 보는 차례에서 맨앞으로를 클릭하여 줍니다.</br>맨 앞으로 설정을 하면 캔들에 가려서 잘 안보이던 시그널 타점을 가로 선으로 확인 가능합니다.', thumbnailUrl : '/images/basel/chart-setting-4.png'},
                      {description: '<b>5.</b> 앞의 설명과 같이 Wallet 체크박스 해제와 Basel 보는 차례 맨앞으로를 설정하면 왼쪽과 같이 매매 시그널만 볼 수 있습니다.', thumbnailUrl : '/images/basel/chart-setting-5.png'},
                  ]"
              ></ExpendableCard>
              <ExpendableCard
                  title="시드설정"
                  :contents="[
                      {description: '<b>1.</b> 매매시그널이 아닌 시드 비교 그래프만 보려면 먼저 지표 옆의 톱니바퀴 같이 생긴 설정을 눌러줍니다.', thumbnailUrl : '/images/basel/seed-1.png'},
                      {description: '<b>2.</b> 위와 같은 설정이 나오면 BuySell Wallet과 JohnBer Wallet을 빼고 다른 체크박스를 모두 해제합니다.', thumbnailUrl : '/images/basel/seed-2.png'},
                      {description: '<b>3.</b> Wallet 빼고 다른 체크박스를 모두 해제하였으면, 좌측 상단에 빨간 네모 안의 &quot;감추기&quot;(눈모양)을 클릭합니다.', thumbnailUrl : '/images/basel/seed-3.png'},
                      {description: '<b>4.</b> Wallet만 체크 및 차트 보기 해제를 하면 왼쪽과 같은 화며이 출력됩니다.</br> 파란선은 바셀의 시그널대로 매매했을 때의 시드 변화 그래프이고, 빨간선은 존버 했을 시에 시드 변화 그래프 입니다.</br></br> 초기 자본은 기본값이 100으로 설정되어 있고,</br>수수료는 0.1% 슬리피지는 0.1%로 설정되어 있습니다.', thumbnailUrl : '/images/basel/seed-4.png'},
                      {description: '<b>5.</b> 설정에서 인풋을 누르면 백테스트를 시작하는 날짜를 설정 할 수 있고, 거래소의 수수료와 슬리피지를 수정하여 입력 할 수 있습니다.</br></br> (보통 거래소의 수수료는 0.1% 정도이고, 대장주 및 바이낸스에서 거래되는 볼륨 높은 코인들은 슬리피지가 0.1% 입니다.)', thumbnailUrl : '/images/basel/seed-5.png'},
                  ]"
              ></ExpendableCard>
              <ExpendableCard
                  title="분봉설정"
                  :contents="[
                      {description: '바셀 메이저 스윙 버전에서는 30M, 1H, 2H, 3H, 4H, 6H, 12H의 시간봉을 지원합니다.</br>각기 다른 분봉에서 신호가 나오는 시점은 모두 같습니다.'},
                      {description: '위의 분봉 안에서 사용자가 보고 싶은 분봉을 골라서 보시면 됩니다.</br>위의 분봉 외의 다른 분봉으로 선택 할 시에 시그널에 이상이 생길 수 있어 표시한 분봉 외에서는 바셀의 시그널이 나오지 않도록 설정 되어 있습니다.'},
                      {description: '<b>주의)</b> 1H이나 2H의 시드와 12H의 시드가 다르게 표기 될 수 있는데, 이점은 시그널에 차이가 있는것이 아니라 낮은 분봉을 설정 할 시에 과거의 캔들 데이터를 모두 불러오지 못하기 때문에 시드에 변화가 생기는 것 입니다.'},
                      {description: '설명서에 모두 12H로 예시를 든 점은 더 장기적인 데이터를 통하여 시그널의 신뢰도를 최대한으로 검증하기 위함 입니다.'},
                      {description: '<b>EX)</b> BITFINEX 12H BTC/USD : 2013년 4월 2월부터 차트 데이터 지원</br>BITFINEX 2H BTC/USD : 2016년 1월 4월부터 차트 데이터 지원</br> 타임 트레임에 따라서 캔들이 지원 되는 시점이 다름'}
                  ]"
              ></ExpendableCard>
              <ExpendableCard
                  title="알림설정"
                  :contents="[
                      {description: '<b>1.</b> 바셀은 트레이딩뷰에서 BUY와 SELL 신호가 발생 하는 시점에 알람이 울리도록 설정 할 수 있습니다.(무료이용자는 1개만 설정 가능함)</br></br>왼쪽의 스크린샷에서 지표 오른쪽의 ⚪️⚪️⚪️(더보기)를 눌러줍니다.', thumbnailUrl : '/images/basel/alert-1.png'},
                      {description: '<b>2.</b> ⚪️⚪️(더보기)를 눌러 준 뒤에 위 사진의 목록이 나오면 빨간색 네모로 표시한 &quot;Basel ver 6.0에 얼러트 넣기&quot;를 선택합니다.', thumbnailUrl : '/images/basel/alert-2.png'},
                      {description: '<b>3.</b> &quot;얼러트 넣기&quot;를 클릭하면 좌측과 가틍ㄴ 설정창이 나타나게 됩니다. </br></br>알림을 설정하고 싶은 거래소와 종목에서 설정창을 켰으면</br></br>' +
                       '①번에서 BUY나 SELL중에 어떤 신호의 알람을 설정 할 지 선택해줍니다.</br></br>' +
                        '②번은 기본 설정으로 딱 한번으로 설정 되어 있는데 이것을 봉마다 한 번으로 변경하여 줍니다.</br>(딱 한번으로 설정하면 한번 알람이 울리면 다시 설정을 해주지 않으면 알람이 풀림)</br></br>' +
                        '③번 오픈 엔디드 기능은은 트레이딩뷰 유료이용자만 설정 할 수 있는 기능인데 만기시간 없이 알림을 사용하는 것을 뜻합니다.</br>(프리미엄 이용자 전용기능, 체크 하는게 좋음)</br></br>'+
                        '④번은 알람 메시지를 설정해주는 부분 입니다.</br>'+
                        '기본적으로 BUY알람은 Buy Now! 메시지가 설정 되어 있고 SELL알람은 Sell Now! 메시지가 설정 되어 있습니다.</br>'+
                        '(이부분에 추가로 티커를 써줘도 되고 받고 싶으신 양식으로 메세지를 작성 할 수 있습니다.)', thumbnailUrl : '/images/basel/alert-3.png'},
                  ]"
              ></ExpendableCard>
            </ul>
          </div>

          <div class="content4">
            <h3 class="tit">사용효과</h3>
            <div class="tabs">
              <Swiper
                  class="swiper-tabs"
                  :slides-per-view="4"
                  :space-between="10"
              >
                <swiper-slide :class="{on: currentTab === 'BTC'}" v-on:click="currentTab = 'BTC'">BTC</swiper-slide>
                <swiper-slide :class="{on: currentTab === 'ETH'}" v-on:click="currentTab = 'ETH'">ETH</swiper-slide>
                <swiper-slide :class="{on: currentTab === 'XRP'}" v-on:click="currentTab = 'XRP'">XRP</swiper-slide>
                <swiper-slide :class="{on: currentTab === 'BCH'}" v-on:click="currentTab = 'BCH'">BCH</swiper-slide>
                <swiper-slide :class="{on: currentTab === 'LTC'}" v-on:click="currentTab = 'LTC'">LTC</swiper-slide>
                <swiper-slide :class="{on: currentTab === 'ADA'}" v-on:click="currentTab = 'ADA'">ADA</swiper-slide>
                <swiper-slide :class="{on: currentTab === 'EOS'}" v-on:click="currentTab = 'EOS'">EOS</swiper-slide>
                <swiper-slide :class="{on: currentTab === 'TRX'}" v-on:click="currentTab = 'TRX'">TRX</swiper-slide>
                <swiper-slide :class="{on: currentTab === 'XLM'}" v-on:click="currentTab = 'XLM'">XLM</swiper-slide>

              </Swiper>
            </div>
            <div class="tabs-cnt">
              <div id="btc" v-show="currentTab === 'BTC'" class="tab-cnt">
                <ul>
                  <li style="margin-bottom: 10px">
                    <p class="tit">BTC/KRW, 12H, BITHUMB</p>
                    <ul class="info">
                      <li>초기설정시드 : 100 만원</li>
                      <li>현재 바셀시드 : 66428 만원</li>
                      <li>현재 존버시드 : 4110 만원</li>
                    </ul>
                    <p class="sub">수수료 0.1% 슬리피지0.1% 적용 시의 결과</p>
                    <div class="img-wrap">
                      <ImageModal image-url="~@/assets/images/basel/btckrw.png"/>
                    </div>
                    <div class="tx-wrap">
                      파란선은 바셀대로 했을때의 변화 그래포이고, 빨간선은 존버시에 시드 변화 그래프 입니다.
                      <br/><br/>
                      바셀은 주가가 상승 할 때 같이 시드를 상승시키고 주가가 떨어 질 때 매매를 쉬어주는 과정을 반복하여 장기적인 시드의 우상향을 목표로 만들어진 알고리즘 입니다.
                      <br/><br/>
                      2017년 불장의 고점 이후에 주가가 하락 할 때도 꾸준히 시드를 우상향하면서 시드관리를 잘해주고 있는 모습입니다.
                      <br/><br/>
                      꾸준히 우상향을 잘 쌓아가며 신고가를 갱신중입니다.
                    </div>
                  </li>
                  <li>
                    <p class="tit">BTC/USD, 12H, BITFINEX</p>
                    <ul class="info">
                      <li>초기설정시드 : 100 $</li>
                      <li>현재 바셀시드 : 59825 $</li>
                      <li>현재 존버시드 : 22107 $</li>
                    </ul>
                    <p class="sub">수수료 0.1% 슬리피지0.1% 적용 시의 결과</p>
                    <div class="img-wrap">
                      <ImageModal image-url="~@/assets/images/basel/btcusd.png"/>
                    </div>
                    <div class="tx-wrap">
                      파란선은 바셀대로 했을때의 변화 그래포이고, 빨간선은 존버시에 시드 변화 그래프 입니다.
                      <br/><br/>
                      바셀은 주가가 상승 할 때 같이 시드를 상승시키고 주가가 떨어 질 때 매매를 쉬어주는 과정을 반복하여 장기적인 시드의 우상향을 목표로 만들어진 알고리즘 입니다.
                      <br/><br/>
                      2017년 불장의 고점 이후에 주가가 하락 할 때도 꾸준히 시드를 우상향하면서 시드관리를 잘해주고 있는 모습입니다.
                      <br/><br/>
                      꾸준히 우상향을 잘 쌓아가며 신고가를 갱신중입니다.
                    </div>
                  </li>
                </ul>
              </div>
              <div id="eth" v-show="currentTab === 'ETH'" class="tab-cnt">
                <ul>
                  <li style="margin-bottom: 10px">
                    <p class="tit">ETH/KRW, 12H, BITHUMB</p>
                    <ul class="info">
                      <li>초기설정시드 : 100 만원</li>
                      <li>현재 바셀시드 : 2768 만원</li>
                      <li>현재 존버시드 : 156 만원</li>
                    </ul>
                    <p class="sub">수수료 0.1% 슬리피지0.1% 적용 시의 결과</p>
                    <div class="img-wrap">
                      <ImageModal image-url="~@/assets/images/basel/ethkrw.png"/>
                    </div>
                    <div class="tx-wrap">
                      파란선은 바셀대로 했을때의 변화 그래포이고, 빨간선은 존버시에 시드 변화 그래프 입니다.
                      <br/><br/>
                      바셀은 주가가 상승 할 때 같이 시드를 상승시키고 주가가 떨어 질 때 매매를 쉬어주는 과정을 반복하여 장기적인 시드의 우상향을 목표로 만들어진 알고리즘 입니다.
                      <br/><br/>
                      2017년 불장의 고점 이후에 주가가 하락 할 때도 꾸준히 시드를 우상향하면서 시드관리를 잘해주고 있는 모습입니다.
                      <br/><br/>
                      꾸준히 우상향을 잘 쌓아가며 신고가를 갱신중입니다.
                    </div>
                  </li>
                  <li>
                    <p class="tit">ETH/USD, 12H, BITFINEX</p>
                    <ul class="info">
                      <li>초기설정시드 : 100 $</li>
                      <li>현재 바셀시드 : 16860 $</li>
                      <li>현재 존버시드 : 10399 $</li>
                    </ul>
                    <p class="sub">수수료 0.1% 슬리피지0.1% 적용 시의 결과</p>
                    <div class="img-wrap">
                      <ImageModal image-url="~@/assets/images/basel/ethusd.png"/>
                    </div>
                    <div class="tx-wrap">
                      파란선은 바셀대로 했을때의 변화 그래포이고, 빨간선은 존버시에 시드 변화 그래프 입니다.
                      <br/><br/>
                      바셀은 주가가 상승 할 때 같이 시드를 상승시키고 주가가 떨어 질 때 매매를 쉬어주는 과정을 반복하여 장기적인 시드의 우상향을 목표로 만들어진 알고리즘 입니다.
                      <br/><br/>
                      2017년 불장의 고점 이후에 주가가 하락 할 때도 꾸준히 시드를 우상향하면서 시드관리를 잘해주고 있는 모습입니다.
                      <br/><br/>
                      꾸준히 우상향을 잘 쌓아가며 신고가를 갱신중입니다.
                    </div>
                  </li>
                </ul>
              </div>
              <div id="xrp" v-show="currentTab === 'XRP'" class="tab-cnt">
                <ul>
                  <li style="margin-bottom: 10px">
                    <p class="tit">XRP/KRW, 12H, BITHUMB</p>
                    <ul class="info">
                      <li>초기설정시드 : 100 만원</li>
                      <li>현재 바셀시드 : 1325 만원</li>
                      <li>현재 존버시드 : 31 만원</li>
                    </ul>
                    <p class="sub">수수료 0.1% 슬리피지0.1% 적용 시의 결과</p>
                    <div class="img-wrap">
                      <ImageModal image-url="~@/assets/images/basel/xrpkrw.png"/>
                    </div>
                    <div class="tx-wrap">
                      파란선은 바셀대로 했을때의 변화 그래포이고, 빨간선은 존버시에 시드 변화 그래프 입니다.
                      <br/><br/>
                      바셀은 주가가 상승 할 때 같이 시드를 상승시키고 주가가 떨어 질 때 매매를 쉬어주는 과정을 반복하여 장기적인 시드의 우상향을 목표로 만들어진 알고리즘 입니다.
                      <br/><br/>
                      2017년 불장의 고점 이후에 주가가 하락 할 때도 꾸준히 시드를 우상향하면서 시드관리를 잘해주고 있는 모습입니다.
                      <br/><br/>
                      꾸준히 우상향을 잘 쌓아가며 신고가를 갱신중입니다.
                    </div>
                  </li>
                  <li>
                    <p class="tit">XRP/USD, 12H, BITFINEX</p>
                    <ul class="info">
                      <li>초기설정시드 : 100 $</li>
                      <li>현재 바셀시드 : 688 $</li>
                      <li>현재 존버시드 : 93 $</li>
                    </ul>
                    <p class="sub">수수료 0.1% 슬리피지0.1% 적용 시의 결과</p>
                    <div class="img-wrap">
                      <ImageModal image-url="~@/assets/images/basel/xrpusd.png"/>
                    </div>
                    <div class="tx-wrap">
                      파란선은 바셀대로 했을때의 변화 그래포이고, 빨간선은 존버시에 시드 변화 그래프 입니다.
                      <br/><br/>
                      바셀은 주가가 상승 할 때 같이 시드를 상승시키고 주가가 떨어 질 때 매매를 쉬어주는 과정을 반복하여 장기적인 시드의 우상향을 목표로 만들어진 알고리즘 입니다.
                      <br/><br/>
                      2017년 불장의 고점 이후에 주가가 하락 할 때도 꾸준히 시드를 우상향하면서 시드관리를 잘해주고 있는 모습입니다.
                      <br/><br/>
                      꾸준히 우상향을 잘 쌓아가며 신고가를 갱신중입니다.
                    </div>
                  </li>
                </ul>
              </div>
              <div id="bch" v-show="currentTab === 'BCH'" class="tab-cnt">
                <ul>
                  <li style="margin-bottom: 10px">
                    <p class="tit">BCH/KRW, 12H, BITHUMB</p>
                    <ul class="info">
                      <li>초기설정시드 : 100 만원</li>
                      <li>현재 바셀시드 : 1003 만원</li>
                      <li>현재 존버시드 : 22 만원</li>
                    </ul>
                    <p class="sub">수수료 0.1% 슬리피지0.1% 적용 시의 결과</p>
                    <div class="img-wrap">
                      <ImageModal image-url="~@/assets/images/basel/bchkrw.png"/>
                    </div>
                    <div class="tx-wrap">
                      파란선은 바셀대로 했을때의 변화 그래포이고, 빨간선은 존버시에 시드 변화 그래프 입니다.
                      <br/><br/>
                      바셀은 주가가 상승 할 때 같이 시드를 상승시키고 주가가 떨어 질 때 매매를 쉬어주는 과정을 반복하여 장기적인 시드의 우상향을 목표로 만들어진 알고리즘 입니다.
                      <br/><br/>
                      2017년 불장의 고점 이후에 주가가 하락 할 때도 꾸준히 시드를 우상향하면서 시드관리를 잘해주고 있는 모습입니다.
                      <br/><br/>
                      꾸준히 우상향을 잘 쌓아가며 신고가를 갱신중입니다.
                    </div>
                  </li>
                  <li>
                    <p class="tit">BCH/USD, 12H, COINBASE</p>
                    <ul class="info">
                      <li>초기설정시드 : 100 $</li>
                      <li>현재 바셀시드 : 490 $</li>
                      <li>현재 존버시드 : 17 $</li>
                    </ul>
                    <p class="sub">수수료 0.1% 슬리피지0.1% 적용 시의 결과</p>
                    <div class="img-wrap">
                      <ImageModal image-url="~@/assets/images/basel/bchusd.png"/>
                    </div>
                    <div class="tx-wrap">
                      파란선은 바셀대로 했을때의 변화 그래포이고, 빨간선은 존버시에 시드 변화 그래프 입니다.
                      <br/><br/>
                      바셀은 주가가 상승 할 때 같이 시드를 상승시키고 주가가 떨어 질 때 매매를 쉬어주는 과정을 반복하여 장기적인 시드의 우상향을 목표로 만들어진 알고리즘 입니다.
                      <br/><br/>
                      2017년 불장의 고점 이후에 주가가 하락 할 때도 꾸준히 시드를 우상향하면서 시드관리를 잘해주고 있는 모습입니다.
                      <br/><br/>
                      꾸준히 우상향을 잘 쌓아가며 신고가를 갱신중입니다.
                    </div>
                  </li>
                </ul>
              </div>
              <div id="ltc" v-show="currentTab === 'LTC'" class="tab-cnt">
                <ul>
                  <li style="margin-bottom: 10px">
                    <p class="tit">LTC/KRW, 12H, BITHUMB</p>
                    <ul class="info">
                      <li>초기설정시드 : 100 만원</li>
                      <li>현재 바셀시드 : 348 만원</li>
                      <li>현재 존버시드 : 40 만원</li>
                    </ul>
                    <p class="sub">수수료 0.1% 슬리피지0.1% 적용 시의 결과</p>
                    <div class="img-wrap">
                      <ImageModal image-url="~@/assets/images/basel/ltckrw.png"/>
                    </div>
                    <div class="tx-wrap">
                      파란선은 바셀대로 했을때의 변화 그래포이고, 빨간선은 존버시에 시드 변화 그래프 입니다.
                      <br/><br/>
                      바셀은 주가가 상승 할 때 같이 시드를 상승시키고 주가가 떨어 질 때 매매를 쉬어주는 과정을 반복하여 장기적인 시드의 우상향을 목표로 만들어진 알고리즘 입니다.
                      <br/><br/>
                      2017년 불장의 고점 이후에 주가가 하락 할 때도 꾸준히 시드를 우상향하면서 시드관리를 잘해주고 있는 모습입니다.
                      <br/><br/>
                      꾸준히 우상향을 잘 쌓아가며 신고가를 갱신중입니다.
                    </div>
                  </li>
                  <li>
                    <p class="tit">LTC/USD, 12H, BITFINEX</p>
                    <ul class="info">
                      <li>초기설정시드 : 100 $</li>
                      <li>현재 바셀시드 : 11668 $</li>
                      <li>현재 존버시드 4512 $</li>
                    </ul>
                    <p class="sub">수수료 0.1% 슬리피지0.1% 적용 시의 결과</p>
                    <div class="img-wrap">
                      <ImageModal image-url="~@/assets/images/basel/ltcusd.png"/>
                    </div>
                    <div class="tx-wrap">
                      파란선은 바셀대로 했을때의 변화 그래포이고, 빨간선은 존버시에 시드 변화 그래프 입니다.
                      <br/><br/>
                      바셀은 주가가 상승 할 때 같이 시드를 상승시키고 주가가 떨어 질 때 매매를 쉬어주는 과정을 반복하여 장기적인 시드의 우상향을 목표로 만들어진 알고리즘 입니다.
                      <br/><br/>
                      2017년 불장의 고점 이후에 주가가 하락 할 때도 꾸준히 시드를 우상향하면서 시드관리를 잘해주고 있는 모습입니다.
                      <br/><br/>
                      꾸준히 우상향을 잘 쌓아가며 신고가를 갱신중입니다.
                    </div>
                  </li>
                </ul>
              </div>
              <div id="ada" v-show="currentTab === 'ADA'" class="tab-cnt">
                <ul>
                  <li style="margin-bottom: 10px">
                    <p class="tit">ADA/KRW, 12H, BITHUMB</p>
                    <ul class="info">
                      <li>초기설정시드 : 100 만원</li>
                      <li>현재 바셀시드 : 906 만원</li>
                      <li>현재 존버시드 : 243 만원</li>
                    </ul>
                    <p class="sub">수수료 0.1% 슬리피지0.1% 적용 시의 결과</p>
                    <div class="img-wrap">
                      <ImageModal image-url="~@/assets/images/basel/adakrw.png"/>
                    </div>
                    <div class="tx-wrap">
                      파란선은 바셀대로 했을때의 변화 그래포이고, 빨간선은 존버시에 시드 변화 그래프 입니다.
                      <br/><br/>
                      바셀은 주가가 상승 할 때 같이 시드를 상승시키고 주가가 떨어 질 때 매매를 쉬어주는 과정을 반복하여 장기적인 시드의 우상향을 목표로 만들어진 알고리즘 입니다.
                      <br/><br/>
                      2017년 불장의 고점 이후에 주가가 하락 할 때도 꾸준히 시드를 우상향하면서 시드관리를 잘해주고 있는 모습입니다.
                      <br/><br/>
                      꾸준히 우상향을 잘 쌓아가며 신고가를 갱신중입니다.
                    </div>
                  </li>
                  <li>
                    <p class="tit">ADA/USD, 12H, BINANCE</p>
                    <ul class="info">
                      <li>초기설정시드 : 100 $</li>
                      <li>현재 바셀시드 : 2766 $</li>
                      <li>현재 존버시드 : 241 $</li>
                    </ul>
                    <p class="sub">수수료 0.1% 슬리피지0.1% 적용 시의 결과</p>
                    <div class="img-wrap">
                      <ImageModal image-url="~@/assets/images/basel/adausd.png"/>
                    </div>
                    <div class="tx-wrap">
                      파란선은 바셀대로 했을때의 변화 그래포이고, 빨간선은 존버시에 시드 변화 그래프 입니다.
                      <br/><br/>
                      바셀은 주가가 상승 할 때 같이 시드를 상승시키고 주가가 떨어 질 때 매매를 쉬어주는 과정을 반복하여 장기적인 시드의 우상향을 목표로 만들어진 알고리즘 입니다.
                      <br/><br/>
                      2017년 불장의 고점 이후에 주가가 하락 할 때도 꾸준히 시드를 우상향하면서 시드관리를 잘해주고 있는 모습입니다.
                      <br/><br/>
                      꾸준히 우상향을 잘 쌓아가며 신고가를 갱신중입니다.
                    </div>
                  </li>
                </ul>
              </div>
              <div id="eos" v-show="currentTab === 'EOS'" class="tab-cnt">
                <ul>
                  <li style="margin-bottom: 10px">
                    <p class="tit">EOS/KRW, 12H, BITHUMB</p>
                    <ul class="info">
                      <li>초기설정시드 : 100 만원</li>
                      <li>현재 바셀시드 : 541 만원</li>
                      <li>현재 존버시드 : 27 만원</li>
                    </ul>
                    <p class="sub">수수료 0.1% 슬리피지0.1% 적용 시의 결과</p>
                    <div class="img-wrap">
                      <ImageModal image-url="~@/assets/images/basel/eoskrw.png"/>
                    </div>
                    <div class="tx-wrap">
                      파란선은 바셀대로 했을때의 변화 그래포이고, 빨간선은 존버시에 시드 변화 그래프 입니다.
                      <br/><br/>
                      바셀은 주가가 상승 할 때 같이 시드를 상승시키고 주가가 떨어 질 때 매매를 쉬어주는 과정을 반복하여 장기적인 시드의 우상향을 목표로 만들어진 알고리즘 입니다.
                      <br/><br/>
                      2017년 불장의 고점 이후에 주가가 하락 할 때도 꾸준히 시드를 우상향하면서 시드관리를 잘해주고 있는 모습입니다.
                      <br/><br/>
                      꾸준히 우상향을 잘 쌓아가며 신고가를 갱신중입니다.
                    </div>
                  </li>
                  <li>
                    <p class="tit">EOS/USD, 12H, BITFINEX</p>
                    <ul class="info">
                      <li>초기설정시드 : 100 $</li>
                      <li>현재 바셀시드 : 1270 $</li>
                      <li>현재 존버시드 : 147 $</li>
                    </ul>
                    <p class="sub">수수료 0.1% 슬리피지0.1% 적용 시의 결과</p>
                    <div class="img-wrap">
                      <ImageModal image-url="~@/assets/images/basel/eosusd.png"/>
                    </div>
                    <div class="tx-wrap">
                      파란선은 바셀대로 했을때의 변화 그래포이고, 빨간선은 존버시에 시드 변화 그래프 입니다.
                      <br/><br/>
                      바셀은 주가가 상승 할 때 같이 시드를 상승시키고 주가가 떨어 질 때 매매를 쉬어주는 과정을 반복하여 장기적인 시드의 우상향을 목표로 만들어진 알고리즘 입니다.
                      <br/><br/>
                      2017년 불장의 고점 이후에 주가가 하락 할 때도 꾸준히 시드를 우상향하면서 시드관리를 잘해주고 있는 모습입니다.
                      <br/><br/>
                      꾸준히 우상향을 잘 쌓아가며 신고가를 갱신중입니다.
                    </div>
                  </li>
                </ul>
              </div>
              <div id="trx" v-show="currentTab === 'TRX'" class="tab-cnt">
                <ul>
                  <li style="margin-bottom: 10px">
                    <p class="tit">TRX/KRW, 12H, BITHUMB</p>
                    <ul class="info">
                      <li>초기설정시드 : 100 만원</li>
                      <li>현재 바셀시드 : 191 만원</li>
                      <li>현재 존버시드 : 53 만원</li>
                    </ul>
                    <p class="sub">수수료 0.1% 슬리피지0.1% 적용 시의 결과</p>
                    <div class="img-wrap">
                      <ImageModal image-url="~@/assets/images/basel/trxkrw.png"/>
                    </div>
                    <div class="tx-wrap">
                      파란선은 바셀대로 했을때의 변화 그래포이고, 빨간선은 존버시에 시드 변화 그래프 입니다.
                      <br/><br/>
                      바셀은 주가가 상승 할 때 같이 시드를 상승시키고 주가가 떨어 질 때 매매를 쉬어주는 과정을 반복하여 장기적인 시드의 우상향을 목표로 만들어진 알고리즘 입니다.
                      <br/><br/>
                      2017년 불장의 고점 이후에 주가가 하락 할 때도 꾸준히 시드를 우상향하면서 시드관리를 잘해주고 있는 모습입니다.
                      <br/><br/>
                      꾸준히 우상향을 잘 쌓아가며 신고가를 갱신중입니다.
                    </div>
                  </li>
                  <li>
                    <p class="tit">TRX/USD, 12H, BITFINEX</p>
                    <ul class="info">
                      <li>초기설정시드 : 100 $</li>
                      <li>현재 바셀시드 : 61 $</li>
                      <li>현재 존버시드 : 58 $</li>
                    </ul>
                    <p class="sub">수수료 0.1% 슬리피지0.1% 적용 시의 결과</p>
                    <div class="img-wrap">
                      <ImageModal image-url="~@/assets/images/basel/trxusd.png"/>
                    </div>
                    <div class="tx-wrap">
                      파란선은 바셀대로 했을때의 변화 그래포이고, 빨간선은 존버시에 시드 변화 그래프 입니다.
                      <br/><br/>
                      바셀은 주가가 상승 할 때 같이 시드를 상승시키고 주가가 떨어 질 때 매매를 쉬어주는 과정을 반복하여 장기적인 시드의 우상향을 목표로 만들어진 알고리즘 입니다.
                      <br/><br/>
                      2017년 불장의 고점 이후에 주가가 하락 할 때도 꾸준히 시드를 우상향하면서 시드관리를 잘해주고 있는 모습입니다.
                      <br/><br/>
                      꾸준히 우상향을 잘 쌓아가며 신고가를 갱신중입니다.
                    </div>
                  </li>
                </ul>
              </div>
              <div id="xlm" v-show="currentTab === 'XLM'" class="tab-cnt">
                <ul>
                  <li style="margin-bottom: 10px">
                    <p class="tit">XLM/KRW, 12H, BITHUMB</p>
                    <ul class="info">
                      <li>초기설정시드 : 100 만원</li>
                      <li>현재 바셀시드 : 456 만원</li>
                      <li>현재 존버시드 : 251 만원</li>
                    </ul>
                    <p class="sub">수수료 0.1% 슬리피지0.1% 적용 시의 결과</p>
                    <div class="img-wrap">
                      <ImageModal image-url="~@/assets/images/basel/xrpkrw.png"/>
                    </div>
                    <div class="tx-wrap">
                      파란선은 바셀대로 했을때의 변화 그래포이고, 빨간선은 존버시에 시드 변화 그래프 입니다.
                      <br/><br/>
                      바셀은 주가가 상승 할 때 같이 시드를 상승시키고 주가가 떨어 질 때 매매를 쉬어주는 과정을 반복하여 장기적인 시드의 우상향을 목표로 만들어진 알고리즘 입니다.
                      <br/><br/>
                      2017년 불장의 고점 이후에 주가가 하락 할 때도 꾸준히 시드를 우상향하면서 시드관리를 잘해주고 있는 모습입니다.
                      <br/><br/>
                      꾸준히 우상향을 잘 쌓아가며 신고가를 갱신중입니다.
                    </div>
                  </li>
                  <li>
                    <p class="tit">XLM/USD, 12H, BITFINEX</p>
                    <ul class="info">
                      <li>초기설정시드 : 100 $</li>
                      <li>현재 바셀시드 : 503 $</li>
                      <li>현재 존버시드 : 100 $</li>
                    </ul>
                    <p class="sub">수수료 0.1% 슬리피지0.1% 적용 시의 결과</p>
                    <div class="img-wrap">
                      <ImageModal image-url="~@/assets/images/basel/xlmusd.png"/>
                    </div>
                    <div class="tx-wrap">
                      파란선은 바셀대로 했을때의 변화 그래포이고, 빨간선은 존버시에 시드 변화 그래프 입니다.
                      <br/><br/>
                      바셀은 주가가 상승 할 때 같이 시드를 상승시키고 주가가 떨어 질 때 매매를 쉬어주는 과정을 반복하여 장기적인 시드의 우상향을 목표로 만들어진 알고리즘 입니다.
                      <br/><br/>
                      2017년 불장의 고점 이후에 주가가 하락 할 때도 꾸준히 시드를 우상향하면서 시드관리를 잘해주고 있는 모습입니다.
                      <br/><br/>
                      꾸준히 우상향을 잘 쌓아가며 신고가를 갱신중입니다.
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div class="content5">
            <h3 class="tit">REVIEW</h3>
            <ReviewCardList column="2"></ReviewCardList>
          </div>

          <div class="content6">
            <h3 class="tit">DISTRIBUTED BY SSABU</h3>
            <p class="exp">‘정통 트레이딩을 트렌디하게’ 라는 슬로건으로 어려운 차트이론 보다는 간단하지만 의미있는 통계/원리를 기반한 트레이딩 원칙과 아이디어, 그리고 노하우를 공유합니다. </p>
            <div class="swiper-container swiper-sns swiper-sns">
              <div class="swiper-wrapper">
                <div class="swiper-slide"><a href="https://t.me/tradingviewmania"><i class="ico-tel"></i>텔레그램</a></div>
                <div class="swiper-slide"><a href="https://open.kakao.com/o/sDFpV9X"><i class="ico-talk"></i>카카오톡</a></div>
                <div class="swiper-slide"><a href="https://cafe.naver.com/tradingviewmania"><i class="ico-cafe"></i>네이버카페</a></div>
                <div class="swiper-slide"><a href="https://kr.tradingview.com/u/ssabu/"><i class="ico-trade"></i>트레이딩뷰</a></div>
                <div class="swiper-slide"><a href="https://cafe.naver.com/nexontv"><i class="ico-bitman"></i>비트맨</a></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ProductBanner from "../components/ProductBanner";
import apiClient from "../../utils/instance";
import ExpendableCard from "../components/ExpendableCard";
import {Swiper, SwiperSlide} from 'swiper/vue';
import 'swiper/swiper-bundle.css'
import ReviewCardList from "../container/ReviewCardList";
import ImageModal from "../components/ImageModal";

export default {
  name: "Algorithms",
  components: {ImageModal, ReviewCardList, ExpendableCard, ProductBanner, Swiper, SwiperSlide},
  data() {
    return {
      product: null,
      currentTab: 'BTC'
    }
  },
  methods: {},
  async mounted() {
    this.product = (await apiClient.instance.get('/products/basel')).data
  }
}
</script>

<style>
@import '~@/assets/css/main.css';
@import '~@/assets/css/reset.css';
@import '~@/assets/css/content.css';

.faq-exp .img-wrap {
  float: left;
  width: 26%;
  height: 156px;
  border-radius: 8px;
  background: #fff;
}

.faq-exp .tx-wrap {
  float: left;
  width: 74%;
  padding-left: 6%;
  box-sizing: border-box;
}
</style>

